import { render } from "./radarChart.vue?vue&type=template&id=acbd9f7c&scoped=true"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"

import "./radarChart.vue?vue&type=style&index=0&id=acbd9f7c&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbd9f7c"]])

export default __exports__